<template>
  <div
    v-if="initialized"
    class="flex flex-col md:flex-row w-full h-full"
  >
    <TheNavbartopPartner v-if="mq.isMobile" />
    <NavbarDesktopProject v-else />
    <main
      id="page"
      class="h-full w-full"
    >
      <div class="h-full w-full">
        <OutOfOfficeBanner
          v-if="current_client.attributes.ooo"
          :client="current_client"
          :profile="current_profile"
        />
        <router-view />
      </div>
    </main>
    <TheNotificationsSidebar v-show="show_notification_sidebar" />
  </div>
  <ButtonImpersonateStop
    v-if="current_profile_true.type === PROFILE_TYPES.EMPLOYEE"
    :profile="current_profile"
  />
</template>

<script>
import NavbarDesktopProject from '@/app/_partners/components/navbar/TheNavbarDesktopProject.vue';
import TheNavbartopPartner from '@/app/_partners/components/navbar/TheNavbartopPartner.vue';
import OutOfOfficeBanner from '@/app/shared_components/banner/TheOutOfOfficeBanner.vue';
import profile_mixin from '@/app/util/profile_mixin';
import ButtonImpersonateStop from '@/app/shared_components/buttons/ButtonImpersonateStop.vue';
import TheNotificationsSidebar from '@/app/shared_components/navbar/notifications/TheNotificationsSidebar.vue';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';

export default {
  name: 'Partner',
  components: {
    NavbarDesktopProject,
    OutOfOfficeBanner,
    ButtonImpersonateStop,
    TheNavbartopPartner,
    TheNotificationsSidebar,
  },
  mixins: [profile_mixin],
  computed: {
    show_notification_sidebar() {
      return this.sidebar_type === SIDEBAR_NOTIFICATIONS;
    },
  },

  async created() {
    await this.initProfile();
  },
};
</script>
